import type { AnyAction } from '@reduxjs/toolkit';
import { FetchClientAPIKeysRoutine } from '../routines';
import type { IApiKeysListState } from '../interfaces';

export const initialState: IApiKeysListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const apiKeysListReducer = (
  state: IApiKeysListState = initialState,
  action: AnyAction,
): IApiKeysListState => {
  switch (action.type) {
    case FetchClientAPIKeysRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchClientAPIKeysRoutine.REQUEST:
      return {
        ...state,
        data: [],
        isFetching: true,
        error: null,
      };
    case FetchClientAPIKeysRoutine.FAILURE:
      return {
        ...state,
        data: [],
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
